let startTime = new Date().getTime();
let setIntervalHandle = null;
let setDetails = null;
class CountdownTimer {
    static setHook(_setDetails){
        if(_setDetails){
            setDetails=_setDetails;
        }
    }

    static start(countDown, _setDetails){
        startTime = new Date().getTime();
        if(_setDetails){
            setDetails = _setDetails;
        }else if(!_setDetails && !setDetails){
            return;
        }
        if(setIntervalHandle){
            clearInterval(setIntervalHandle);
        }
        const dynamicEta = countDown;
        // const interval = 60000;
        const interval = 20000;

        let totalMinutes = dynamicEta.totalMinutes;
        let countdownHours = totalMinutes/60;
        let countdownMins = totalMinutes%60;

        // let dynamicEtaTotalMinutes = (dynamicEta.hours*60) +  + dynamicEta.minutes;

        const setTimerExpired = (hours)=>{
            console.log("EXPIRED")
            dynamicEta.timerExpired = true;
            setDetails({...dynamicEta});
        };        
        const setCountdownHours = (hours)=>{
            countdownHours = hours;
            dynamicEta.hours = hours;
            setDetails({...dynamicEta});
        };
        const setCountdownMins = (mins)=>{
            countdownMins = mins;
            dynamicEta.minutes = mins;
            setDetails({...dynamicEta});
        };


        const checkTimerExpired = () => {
            if((countdownHours === 0 || countdownHours === "0" || !countdownHours) 
                && (countdownMins === 0 || countdownMins === "0" || !countdownMins)){
                clearInterval(setIntervalHandle);
                setTimerExpired(true);
            }
        }

        const updateHoursMinsTime = () =>{
            const now = new Date().getTime();
            let timeElapsed = Math.abs(now - startTime);

            const minsElapsed = Math.floor((timeElapsed/1000)/60);
            const hoursElapsed = Math.floor((timeElapsed % 86400000) / 3600000);
            setCountdownHours(Math.floor((dynamicEta.totalMinutes - minsElapsed)/60));
            setCountdownMins((dynamicEta.totalMinutes - minsElapsed)%60);

            checkTimerExpired();
        }

        updateHoursMinsTime();
        setIntervalHandle = setInterval(updateHoursMinsTime, interval);
    }
}

export default CountdownTimer;
